import React from 'react';
import { FieldError } from '@spike/model';
import { Product } from '@spike/product-model';
import { AddOnService } from '@spike/addon-service-model';
import { AddOnSelector, ProductSelector, TextField2 } from 'components/UI';
import { useSingleSaleTableItemSelectorStyles } from 'components/Payments/SingleSale/Table/Item/Selector/SingleSaleTalbeItemSelector.styles';
import { OrderizableTypes } from '@spike/order-model';
import {
    GenericOrderItem,
    isAddOnServiceOrderItem,
    isCustomOrderItem,
    isProductOrderItem
} from 'components/Payments/SingleSale/SingleSale';

export type ItemSelectorProps = {
    item: GenericOrderItem;
    errors?: Array<FieldError>;
    selectedProductIds?: Array<number>;
    selectedAddOnServiceIds?: Array<number>;
    onChange: (type: OrderizableTypes, product?: Product, addonService?: AddOnService, description?: string) => void;
};

export const SingleSaleTableItemSelector: React.FC<ItemSelectorProps> = props => {
    const classes = useSingleSaleTableItemSelectorStyles();

    const orderItemProduct = React.useMemo(
        () => (isProductOrderItem(props.item) && props.item.product?.id ? props.item.product : false),
        [props.item]
    );
    const orderItemAddOnService = React.useMemo(
        () => (isAddOnServiceOrderItem(props.item) && props.item.addOnService?.id ? props.item.addOnService : false),
        [props.item]
    );

    const onChangeHandler = (value?: Product | AddOnService | string) => {
        if (props.item.orderItem.orderizable.type === OrderizableTypes.PRODUCT) {
            props.onChange(props.item.orderItem.orderizable.type, value as Product);
        }

        if (props.item.orderItem.orderizable.type === OrderizableTypes.ADDON_SERVICE) {
            props.onChange(props.item.orderItem.orderizable.type, undefined, value as AddOnService);
        }

        if (props.item.orderItem.orderizable.type === OrderizableTypes.CUSTOM) {
            props.onChange(props.item.orderItem.orderizable.type, undefined, undefined, value as string);
        }
    };

    return (
        <>
            {isProductOrderItem(props.item) && !orderItemProduct && (
                <ProductSelector
                    errors={props.errors}
                    excludedIds={props.selectedProductIds}
                    name={`${props.item.orderItem.uuid}_selection`}
                    onSelect={onChangeHandler}
                />
            )}

            {isAddOnServiceOrderItem(props.item) && !orderItemAddOnService && (
                <AddOnSelector
                    name={`${props.item.orderItem.uuid}_selection`}
                    excludedIds={props.selectedAddOnServiceIds}
                    errors={props.errors}
                    onSelect={onChangeHandler}
                />
            )}

            {isCustomOrderItem(props.item) && (
                <TextField2
                    value={props.item.orderItem.description ?? ''}
                    placeholder="Enter description"
                    name={`${props.item.orderItem.uuid}_description`}
                    errors={props.errors}
                    className={classes.field}
                    onChange={onChangeHandler}
                />
            )}
        </>
    );
};
